import { c as _c } from "react/compiler-runtime";
import { CheckboxPropertiesType } from "@website/ui/checkbox/checkbox.types";
import pick from "lodash-es/pick";
import { useEffect, useRef } from "react";
export const useCheckbox = properties => {
  const $ = _c(7);
  const {
    indeterminate
  } = properties;
  const inputReference = useRef(null);
  let t0;
  let t1;
  if ($[0] !== indeterminate) {
    t0 = () => {
      if (indeterminate && inputReference.current) {
        inputReference.current.indeterminate = true;
      }
    };
    t1 = [indeterminate];
    $[0] = indeterminate;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== properties) {
    t2 = pick(properties, "autoFocus", "disabled", "checked", "name", "onChange", "readOnly", "value");
    $[3] = properties;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = {
      inputProps: {
        ...t2,
        type: "checkbox",
        ref: inputReference
      }
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};